import React from "react";
import { Link } from "react-router-dom";
import { Navigation, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import hero1 from "../../images/slider/1.jpg";
import hero2 from "../../images/slider/2.jpg";
import hero3 from "../../images/slider/3.jpg";

const Hero = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="wpo-hero-slider-s2  wpo-hero-slider-1">
      <div className="swiper-container">
        <div className="swiper-wrapper">
          <Swiper
            // install Swiper modules
            modules={[Navigation, A11y]}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            pagination={{ clickable: true }}
            speed={1800}
            parallax={true}
            navigation
          >
            <SwiperSlide>
              <div
                className="slide-inner slide-bg-image"
                style={{
                  backgroundImage: `url(${hero2})`,
                  backgroundColor: "transparent",
                }}
              >
                <div
                  className="slide-inner slide-bg-image"
                  data-background="assets/images/slider/slide-6.jpg"
                >
                  <div className="container-fluid">
                    <div className="slide-content">
                      <div data-swiper-parallax="300" className="slide-title">
                        <h2>A New Voice For A Brighter Future</h2>
                      </div>
                      <div data-swiper-parallax="400" className="slide-text">
                        <p>
                          Taisha St. Jean Tard is dedicated to empowering our
                          community, creating economic opportunities, and
                          ensuring every voice is heard in Erie County's 2nd
                          District.
                        </p>
                      </div>
                      <div className="clearfix"></div>
                      <div data-swiper-parallax="500" className="slide-btns">
                        <a
                          href
                          onClick={ClickHandler}
                          href="https://secure.actblue.com/donate/taishaforeriecounty"
                          className="theme-btn-s3"
                          target="_blank"
                        >
                          MAKE A DONATION
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="slide-inner slide-bg-image"
                style={{ backgroundImage: `url(${hero1})` }}
              >
                <div className="container-fluid">
                  <div className="slide-content">
                    <div data-swiper-parallax="300" className="slide-title">
                      <h2>Building a Stronger Community Together</h2>
                    </div>
                    <div data-swiper-parallax="400" className="slide-text">
                      <p>
                        With a focus on transparency, fairness, and equality,
                        Taisha aims to create lasting change that uplifts our
                        entire community.
                      </p>
                    </div>
                    <div className="clearfix"></div>
                    <div data-swiper-parallax="500" className="slide-btns">
                      <Link
                        onClick={ClickHandler}
                        to="/about"
                        className="theme-btn-s3"
                      >
                        LEARN MORE
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="slide-inner slide-bg-image"
                style={{ backgroundImage: `url(${hero3})` }}
              >
                <div className="container-fluid">
                  <div className="slide-content">
                    <div data-swiper-parallax="300" className="slide-title">
                      <h2>Your Voice Matters in Erie County</h2>
                    </div>
                    <div data-swiper-parallax="400" className="slide-text">
                      <p>
                        Join Taisha St. Jean Tard in advocating for policies
                        that empower families, improve access to housing,
                        education, and economic opportunities
                      </p>
                    </div>
                    <div className="clearfix"></div>
                    <div data-swiper-parallax="500" className="slide-btns">
                      <Link
                        onClick={ClickHandler}
                        to="/volunteer"
                        className="theme-btn-s3"
                      >
                        GET INVOLVED
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            ...
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Hero;
